"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThemeProvider = exports.Text = exports.makeStyles = exports.useThemeBase = exports.useIsThemeProvided = exports.ViewPortOutOfRangeError = exports.useBrowserFontSizeFactor = exports.useWindowInnerSize = exports.useDomRect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/ban-types */
var react_1 = require("react");
var CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
var styles_1 = require("@material-ui/core/styles");
var styles_2 = require("@material-ui/core/styles");
var useWindowInnerSize_1 = require("powerhooks/useWindowInnerSize");
Object.defineProperty(exports, "useWindowInnerSize", { enumerable: true, get: function () { return useWindowInnerSize_1.useWindowInnerSize; } });
var color_1 = require("./color");
var typography_1 = require("./typography");
var color_2 = require("./color");
var shadows_1 = require("./shadows");
var responsive_1 = require("./responsive");
var Text_1 = require("../Text");
var useBrowserFontSizeFactor_1 = require("powerhooks/useBrowserFontSizeFactor");
Object.defineProperty(exports, "useBrowserFontSizeFactor", { enumerable: true, get: function () { return useBrowserFontSizeFactor_1.useBrowserFontSizeFactor; } });
var spacing_1 = require("./spacing");
var tss_react_1 = require("tss-react");
var icon_1 = require("./icon");
var SplashScreen_1 = require("./SplashScreen");
var ViewPortAdapter_1 = require("powerhooks/ViewPortAdapter");
Object.defineProperty(exports, "ViewPortOutOfRangeError", { enumerable: true, get: function () { return ViewPortAdapter_1.ViewPortOutOfRangeError; } });
var assert_1 = require("tsafe/assert");
var memoizee_1 = __importDefault(require("memoizee"));
var id_1 = require("tsafe/id");
var useDomRect_1 = require("powerhooks/useDomRect");
Object.defineProperty(exports, "useDomRect", { enumerable: true, get: function () { return useDomRect_1.useDomRect; } });
var themeBaseContext = react_1.createContext(undefined);
/** Used internally, do not export globally */
function useIsThemeProvided() {
    var theme = react_1.useContext(themeBaseContext);
    return theme !== undefined;
}
exports.useIsThemeProvided = useIsThemeProvided;
function useThemeBase() {
    var theme = react_1.useContext(themeBaseContext);
    if (theme === undefined) {
        throw new Error("Your app should be wrapped into ThemeProvider");
    }
    return theme;
}
exports.useThemeBase = useThemeBase;
exports.makeStyles = tss_react_1.createMakeStyles({
    "useTheme": useThemeBase,
}).makeStyles;
exports.Text = Text_1.createText({ "useTheme": useThemeBase }).Text;
function createThemeProvider(params) {
    var _a = params.palette, palette = _a === void 0 ? color_1.defaultPalette : _a, _b = params.createColorUseCases, createColorUseCases = _b === void 0 ? color_1.createDefaultColorUseCases : _b, _c = params.getTypographyDesc, getTypographyDesc = _c === void 0 ? typography_1.defaultGetTypographyDesc : _c, _d = params.isReactStrictModeEnabled, isReactStrictModeEnabled = _d === void 0 ? false : _d, _e = params.spacingConfig, spacingConfig = _e === void 0 ? spacing_1.defaultSpacingConfig : _e, _f = params.custom, custom = _f === void 0 ? {} : _f, defaultIsDarkModeEnabled = params.defaultIsDarkModeEnabled, _g = params.getIconSizeInPx, getIconSizeInPx = _g === void 0 ? icon_1.defaultGetIconSizeInPx : _g;
    if (defaultIsDarkModeEnabled !== undefined) {
        color_1.evtIsDarkModeEnabled.state = defaultIsDarkModeEnabled;
    }
    var useTheme = (function () {
        var createTheme = memoizee_1.default(function (isDarkModeEnabled, windowInnerWidth, windowInnerHeight, browserFontSizeFactor) {
            var typographyDesc = getTypographyDesc({
                windowInnerWidth: windowInnerWidth,
                windowInnerHeight: windowInnerHeight,
                browserFontSizeFactor: browserFontSizeFactor,
            });
            var useCases = createColorUseCases({
                palette: palette,
                isDarkModeEnabled: isDarkModeEnabled,
            });
            return id_1.id(__assign(__assign({ "colors": { palette: palette, useCases: useCases }, "typography": typography_1.getComputedTypography({ typographyDesc: typographyDesc }), isDarkModeEnabled: isDarkModeEnabled,
                shadows: shadows_1.shadows, "responsive": responsive_1.createResponsive({ windowInnerWidth: windowInnerWidth }) }, (function () {
                var muiTheme = (isReactStrictModeEnabled
                    ? styles_2.unstable_createMuiStrictModeTheme
                    : styles_2.createTheme)({
                    // https://material-ui.com/customization/palette/#using-a-color-object
                    "typography": typography_1.createMuiTypographyOptions({
                        typographyDesc: typographyDesc,
                    }),
                    "palette": color_2.createMuiPaletteOptions({
                        isDarkModeEnabled: isDarkModeEnabled,
                        palette: palette,
                        useCases: useCases,
                    }),
                    "spacing": function (factor) {
                        return spacingConfig({
                            factor: factor,
                            windowInnerWidth: windowInnerWidth,
                            "rootFontSizePx": typographyDesc.rootFontSizePx,
                        });
                    },
                    "breakpoints": {
                        "values": __assign({ "xs": 0 }, responsive_1.breakpointsValues),
                    },
                });
                return {
                    "spacing": muiTheme.spacing.bind(muiTheme),
                    muiTheme: muiTheme,
                };
            })()), { "iconSizesInPxByName": icon_1.getIconSizesInPxByName({
                    getIconSizeInPx: getIconSizeInPx,
                    windowInnerWidth: windowInnerWidth,
                    "rootFontSizePx": typographyDesc.rootFontSizePx,
                }), custom: custom }));
        }, { "max": 1 });
        function useTheme() {
            var isDarkModeEnabled = color_1.useIsDarkModeEnabled().isDarkModeEnabled;
            var _a = useWindowInnerSize_1.useWindowInnerSize(), windowInnerWidth = _a.windowInnerWidth, windowInnerHeight = _a.windowInnerHeight;
            var browserFontSizeFactor = useBrowserFontSizeFactor_1.useBrowserFontSizeFactor().browserFontSizeFactor;
            return createTheme(isDarkModeEnabled, windowInnerWidth, windowInnerHeight, browserFontSizeFactor);
        }
        return { useTheme: useTheme };
    })().useTheme;
    var SplashScreen = SplashScreen_1.createSplashScreen({ useTheme: useTheme }).SplashScreen;
    var ThemeProvider = (function () {
        function ThemeProviderInner(props) {
            var splashScreen = props.splashScreen, children = props.children;
            var theme = useTheme();
            return (jsx_runtime_1.jsx(themeBaseContext.Provider, __assign({ value: theme }, { children: jsx_runtime_1.jsxs(styles_1.ThemeProvider, __assign({ theme: theme.muiTheme }, { children: [jsx_runtime_1.jsx(CssBaseline_1.default, {}, void 0),
                        jsx_runtime_1.jsx(styles_1.StylesProvider, __assign({ injectFirst: true }, { children: splashScreen === undefined ? (children) : (jsx_runtime_1.jsx(SplashScreen, __assign({}, splashScreen, { children: children }), void 0)) }), void 0)] }), void 0) }), void 0));
        }
        function ThemeProvider(props) {
            var splashScreen = props.splashScreen, getViewPortConfig = props.getViewPortConfig;
            var getConfig = react_1.useCallback(function (params) {
                assert_1.assert(getViewPortConfig !== undefined);
                var config;
                try {
                    config = getViewPortConfig(params);
                }
                catch (error) {
                    if (!(error instanceof ViewPortAdapter_1.ViewPortOutOfRangeError)) {
                        throw error;
                    }
                    var fallbackNode = error.fallbackNode;
                    throw new ViewPortAdapter_1.ViewPortOutOfRangeError((jsx_runtime_1.jsx(ThemeProviderInner, { children: fallbackNode }, void 0)));
                }
                return config;
            }, [getViewPortConfig]);
            var children = (jsx_runtime_1.jsx(ThemeProviderInner, __assign({ splashScreen: splashScreen }, { children: props.children }), void 0));
            return getViewPortConfig === undefined ? (jsx_runtime_1.jsx("div", __assign({ style: { "height": "100vh" } }, { children: children }), void 0)) : (jsx_runtime_1.jsx(ViewPortAdapter_1.ViewPortAdapter, __assign({ getConfig: getConfig }, { children: children }), void 0));
        }
        return { ThemeProvider: ThemeProvider };
    })().ThemeProvider;
    return { ThemeProvider: ThemeProvider, useTheme: useTheme };
}
exports.createThemeProvider = createThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map